(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/draws-redux/assets/javascripts/hooks/use-draw-subscription.js') >= 0) return;  svs.modules.push('/components/sport/draws-redux/assets/javascripts/hooks/use-draw-subscription.js');
"use strict";

const _excluded = ["isLightUpdate"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

const useSocket = svs.components.lbUtils.socket.useSocket;
const products = svs.utils.products;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const _React = React,
  useEffect = _React.useEffect;
const updateDraw = svs.components.sport.drawsRedux.actions.updateDraw;
const globalizedSelectors = svs.components.sport.drawsRedux.globalizedSelectors;
const socket = svs.core.svsSocket.get('/v1/gameinfo-soc');
const cloudApiFeatureToggles = svs.components.lbUtils.cloudApi.cloudApiConstants.cloudApiFeatureToggles;
const VALID_PRODUCTS_FOR_CLOUD_SOCKET_ENDPOINT_DRAW = svs.components.lbUtils.cloudApi.cloudApiConstants.VALID_PRODUCTS_FOR_CLOUD_SOCKET_ENDPOINT_DRAW;

const useDrawSubscription = function (drawNumber, productId) {
  let opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const drawId = "".concat(productId, "_").concat(drawNumber);
  const dispatch = useDispatch();
  const subscriptionUrl = "/draw/1/".concat(products.getSpecificDrawName(productId), "/draws/").concat(drawNumber);
  const draw = useSelector(state => globalizedSelectors.selectById(state, drawId));
  const isLightUpdate = opts.isLightUpdate,
    restOpts = _objectWithoutProperties(opts, _excluded);
  const socketOptions = _objectSpread({
    sendInitialUpdate: false,
    skip: false
  }, restOpts);
  const shouldUseCloudSocketApi = svs.core.detect.feature(cloudApiFeatureToggles[products.getSpecificDrawName(productId).toUpperCase()]) && VALID_PRODUCTS_FOR_CLOUD_SOCKET_ENDPOINT_DRAW.includes(productId);
  useEffect(() => {
    if (!shouldUseCloudSocketApi || !productId || !drawNumber) {
      return undefined;
    }
    const url = "/api/v1/".concat(products.getSpecificDrawName(productId), "/draws/").concat(drawNumber);
    const drawNumberSubscriptionHandler = drawResponse => {
      var _drawResponse$message;
      if (drawResponse !== null && drawResponse !== void 0 && (_drawResponse$message = drawResponse.message) !== null && _drawResponse$message !== void 0 && _drawResponse$message.data) {
        dispatch(updateDraw({
          drawResponse: drawResponse.message.data.draw
        }, {
          isLightUpdate
        }));
      }
    };
    const drawSubscriptionCloud = socket.subscribe(url, drawNumberSubscriptionHandler, {
      sendInitialUpdate: false
    });
    return () => drawSubscriptionCloud.unsubscribe();
  }, [productId, drawNumber, isLightUpdate, dispatch, shouldUseCloudSocketApi]);
  useSocket(subscriptionUrl, drawResponse => {
    if (drawResponse) {
      dispatch(updateDraw({
        drawResponse: drawResponse.draw
      }, {
        isLightUpdate
      }));
    }
  }, _objectSpread(_objectSpread({}, socketOptions), {}, {
    skip: shouldUseCloudSocketApi || restOpts.skip || !productId || !drawNumber
  }));
  return draw;
};
setGlobal('svs.components.sport.drawsRedux.hooks', {
  useDrawSubscription
});

 })(window);